import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const HintTitleStyled = styled(Stack)({
  paddingTop: 8,
  paddingBottom: 8,
});

export const HintContainer = styled('span')({
  display: 'inline-flex',
  transform: 'translateY(2px) translateX(6px)',
});
